import React from "react";
import { ListGroup } from "react-bootstrap";
import { _t } from "../../../../app/i18n/i18n";
import { addParam, push, removeParam } from "../../api/filterUrlMaker";
import { SearchDatePicker, resetDatePickers } from "./SearchDatePicker";

export const OptionsList = ({ options = [], labels = options, ...props }) => {
  return options.map((option, key) =>
    isDateField(option) ? (
      <SearchDatePicker key={key} {...props} option={option} />
    ) : (
      <ListItem
        {...props}
        key={key}
        label={labels[key] || option}
        onClick={() => onClick({ option: props.isValueTranslate ? _t(option) : option, ...props })}
        isActive={isActive({ option: props.isValueTranslate ? _t(option) : option, ...props })}
      />
    )
  );
};

export const ListItem = ({
  label,
  isActive,
  isTranslate,
  onClick,
  children = null,
  className = "m-0 p-2 cursor-pointer ",
}) => (
  <ListGroup.Item className={className + (isActive ? " left-border-highlight text-primary " : "")} onClick={onClick}>
    <span>{isTranslate ? _t(label) : label}</span>
    {children}
  </ListGroup.Item>
);

export const onClick = ({ option, filter, category, allowMultipleSelections = true, allowNoSelections = true }) => {
  const _isActive = isActive({ option, filter, category });
  if (allGlobal.includes(option)) {
    push(removeParam(category));
    resetDatePickers(option);
  } else if (_isActive) {
    if (isLastSelection(filter, category) && !allowNoSelections) return;
    push(removeParam(category, option));
  } else {
    const isAddMode = allowMultipleSelections;
    const queryString = undefined;
    push(addParam(category, option, queryString, isAddMode));
  }
};

const allGlobal = ["All", "すべて", "Global", "グローバル", "All Time", "全期間"];
const isLastSelection = (filter, category) => filter[category].length === 1;
export const isActive = ({ option, filter, category }) =>
  filter[category] ? filter[category].includes(option) : allGlobal.includes(option);
const isDateField = (option) => ["From date", "To date"].includes(option);
